interface Props {
    title: string;
    description: string;
}

export default function StageStepHeader({ title, description }: Props) {
    return (
        <div className="rounded-[14px] border border-white/[0.07] bg-[#212226] px-4 py-3.5 sm:px-5 sm:py-4">
            <h2 className="text-base sm:text-lg font-semibold text-[#F1F0EA]">
                {title}
            </h2>
            <p className="text-sm text-[#6B6C72] mt-1 leading-relaxed">
                {description}
            </p>
        </div>
    );
}
